import type { Bonus, PreviewPage, Volume } from '../types/content';
export const volumes: Volume[] = [{
  label: 'VOLUMEN 01',
  title: 'ARQUITECTURA DEL ORDEN',
  subtitle: 'Organizá los espacios de tu hogar y establecé una forma sencilla de mantenerlos.',
  items: ['Encontrás procedimientos para organizar cocina, baño, dormitorio, living y entrada.', 'Elegís protocolos de 15, 45 o 90 minutos según el tiempo disponible.', 'Utilizás checklists y un calendario de mantenimiento de cuatro semanas.'],
  result: '“Sé cómo organizar cada espacio y mantenerlo.”',
  accent: 'info'
}, {
  label: 'VOLUMEN 02',
  title: 'DOMINIO DE LAS PERTENENCIAS',
  subtitle: 'Decidí qué conservar, qué dejar ir y cómo evitar que los objetos vuelvan a acumularse.',
  items: ['Revisás ropa, libros, herramientas, recuerdos y objetos duplicados.', 'Aplicás criterios prácticos para conservar, reutilizar, donar, vender o reciclar.', 'Organizás tus pertenencias según su utilidad, estado y espacio disponible.'],
  result: '“Sé qué conservar y qué puedo dejar ir.”',
  accent: 'primary'
}, {
  label: 'VOLUMEN 03',
  title: 'HIGIENE DIGITAL Y ATENCIÓN',
  subtitle: 'Simplificá tu entorno digital para encontrar lo que necesitás y reducir las distracciones.',
  items: ['Organizás notificaciones, aplicaciones y pantalla de inicio.', 'Ordenás fotos, archivos, documentos, correo y mensajería.', 'Aplicás procedimientos de mantenimiento para conservar el orden digital.'],
  result: '“Encuentro lo que necesito sin tanto desorden digital.”',
  accent: 'highlight'
}, {
  label: 'VOLUMEN 04',
  title: 'INGENIERÍA DE LA VIDA COTIDIANA',
  subtitle: 'Organizá tus tareas y rutinas para dejar de resolver todo sobre la marcha.',
  items: ['Establecés rutinas de inicio y cierre del día.', 'Organizás limpieza, lavado, reposición de productos y tareas domésticas.', 'Planificás comidas, compras y actividades recurrentes con un calendario doméstico.'],
  result: '“Mi semana está organizada y sé qué tengo que hacer.”',
  accent: 'danger'
}, {
  label: 'VOLUMEN 05',
  title: 'CONSUMO CON INTENCIÓN',
  subtitle: 'Tomá decisiones de compra más conscientes y evitá volver a acumular cosas innecesarias.',
  items: ['Diferenciás necesidades, conveniencia, deseos e impulsos antes de comprar.', 'Aplicás criterios prácticos para supermercado, ropa, tecnología y hogar.', 'Usás un checklist para evaluar precio, utilidad, mantenimiento, espacio y posibles duplicados.'],
  result: '“Compro con más criterio y acumulo menos cosas innecesarias.”',
  accent: 'primary'
}];
export const previewPages: PreviewPage[] = [{
  src: 'https://cdn.magicpatterns.com/uploads/c6Py7J7jRR7KVwweiJig3R/Hoja_1.webp',
  alt: 'Página del kit: Antes de empezar, prepará lo necesario.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/mqHBspFnz39HT51SYQS3UV/Hoja_2.webp',
  alt: 'Página del kit: Cocina, distribución funcional.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/jU3xAg4doNdfUPUs1b6sj4/Hoja_3.webp',
  alt: 'Página del kit: Entrada, llaves, bolsos y calzado.'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5Afim3hNT2rd1ob6x8LBT5/Hoja_4.webp',
  alt: 'Página del kit: Placares y estantes, organizá un sector sin vaciar todo.'
}];
export const bonuses: Bonus[] = [{
  number: '01',
  title: 'RESET EXPRESS DEL HOGAR',
  detail: 'Recuperá rápidamente el orden visible de tu hogar con una secuencia de acciones prioritarias.',
  items: ['Identificás qué zonas despejar primero.', 'Seguís acciones concretas para superficies y objetos fuera de lugar.', 'Usás un checklist para recuperar el orden sin hacerlo todo a la vez.'],
  value: '$12.000'
}, {
  number: '02',
  title: 'ARMARIO FUNCIONAL EN 7 DÍAS',
  detail: 'Organizá tu armario en siete jornadas con un plan preparado para revisar y ordenar tus prendas.',
  items: ['Revisás las prendas según su uso y estado.', 'Organizás categorías, combinaciones y ropa de temporada.', 'Aplicás criterios para mantener el orden.'],
  value: '$10.000'
}, {
  number: '03',
  title: 'DESPEJE DIGITAL EN 60 MINUTOS',
  detail: 'Simplificá tu entorno digital con un protocolo práctico de 60 minutos.',
  items: ['Revisás notificaciones, aplicaciones y pantalla de inicio.', 'Organizás archivos, fotos y elementos de tus dispositivos.', 'Encontrás orientaciones para Android, iPhone, Windows y macOS, más un mantenimiento semanal de 10 minutos.'],
  value: '$9.000'
}, {
  number: '04',
  title: 'SEMANA LIVIANA: PLAN DE 7 DÍAS',
  detail: 'Seguí un plan de siete días para simplificar tu vida cotidiana paso a paso.',
  items: ['Tenés acciones diarias para espacios, pertenencias y entorno digital.', 'Organizás rutinas, compras y planificación semanal.', 'Elegís una versión reducida o ampliada y un plan de mantenimiento de cuatro semanas.'],
  value: '$11.000'
}, {
  number: '05',
  title: 'COMPRA CON CRITERIO',
  detail: 'Evaluá tus compras antes de gastar y evitá sumar cosas que no necesitás.',
  items: ['Aplicás un filtro de cuatro preguntas y un protocolo de espera.', 'Revisás compras de supermercado, ropa, calzado, hogar y tiendas online.', 'Consultás cinco casos resueltos, un checklist de compra y una revisión mensual.'],
  value: '$10.000'
}];
